import ApprovalAction from '../../prat_actions/promotion/approvalAction'

const ApprovalReducer = (state = {
    isapprovalListLoading: true, isapprovalHistoryLoading: false, performingAction: false,
    isSendbackHistoryLoading: false, sendbackHistory: []
}, action) => {
    // let details;
    // console.log(action.type)
    switch (action.type) {

        case ApprovalAction.GET_APPROVAL_LIST_REQUEST:
            return {
                ...state,
                isapprovalListLoading: false,
                approvalList: action.data,
            };

        case ApprovalAction.GET_APPROVAL_LIST_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isapprovalListLoading: false,
                approvalList: action.data
            };

        case ApprovalAction.GET_APPROVAL_LIST_FAILED:
            return {
                ...state,
                isapprovalListLoading: false,
                error: action.error
            };

        case ApprovalAction.GET_SPECIFIC_ACTIVITY_REQUEST:
            return {
                ...state,
                isapprovalListLoading: false,
                specficActivity: action.data,
            };

        case ApprovalAction.GET_SPECIFIC_ACTIVITY_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isspecficActivityLoading: false,
                specficActivity: action.data
            };

        case ApprovalAction.GET_SPECIFIC_ACTIVITY_FAILED:
            return {
                ...state,
                isapprovalListLoading: false,
                error: action.error
            };

        // sUBMIT aPPROVAL

        case ApprovalAction.POST_SUBMIT_APPROVAL_REQUEST:
            return {
                ...state,
                isapprovalListLoading: false,
                submitApproval: action.data,
            };

        case ApprovalAction.POST_SUBMIT_APPROVAL_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isspecficActivityLoading: false,
                submitApproval: action.data
            };

        case ApprovalAction.POST_SUBMIT_APPROVAL_FAILED:
            return {
                ...state,
                isapprovalListLoading: false,
                error: action.error
            };

        //SUBMIT APPROVAL FOR MTFTS

        case ApprovalAction.POST_MTFTS_SUBMIT_APPROVAL_REQUEST:
            return {
                ...state,
                isapprovalListLoading_: false,
                mtfts_submitApproval: action.data,
            };

        case ApprovalAction.POST_MTFTS_SUBMIT_APPROVAL_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isspecficActivityLoading_: false,
                mtfts_submitApproval: action.data
            };

        case ApprovalAction.POST_MTFTS_SUBMIT_APPROVAL_FAILED:
            return {
                ...state,
                isapprovalListLoading_: false,
                error: action.error
            };
        //SUBMIT APPROVAL FOR MTFTS

        // Approval History

        case ApprovalAction.GET_APPROVAL_HISTORY_REQUEST:
            return {
                ...state,
                isapprovalHistoryLoading: true,
            };

        case ApprovalAction.GET_APPROVAL_HISTORY_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isapprovalHistoryLoading: false,
                approvalHistory: action.data
            };

        case ApprovalAction.GET_APPROVAL_HISTORY_FAILED:
            return {
                ...state,
                isapprovalHistoryLoading: false,
                error: action.error
            };

        // Approval Submit

        case ApprovalAction.POST_APPROVAL_SUBMIT_REQUEST:
            return {
                ...state,
                performingAction: true,
            };

        case ApprovalAction.POST_APPROVAL_SUBMIT_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                performingAction: false,
                approvalHistory: action.data
            };

        case ApprovalAction.POST_APPROVAL_SUBMIT_FAILED:
            return {
                ...state,
                performingAction: false,
                error: action.error
            };

        // PRE-OPSO SEND BACK History

        case ApprovalAction.GET_SENDBACK_HISTORY_REQUEST:
            return {
                ...state,
                isSendbackHistoryLoading: true,
            };

        case ApprovalAction.GET_SENDBACK_HISTORY_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isSendbackHistoryLoading: false,
                sendbackHistory: action.data
            };

        case ApprovalAction.GET_SENDBACK_HISTORY_FAILED:
            return {
                ...state,
                isSendbackHistoryLoading: false,
                error: action.error
            };

        // old preopso data 

        case ApprovalAction.OLD_PREOPSO_DATA_REQUEST:
            return {
                ...state,
                isOldPreopsoLoading: true,
            };

        case ApprovalAction.OLD_PREOPSO_DATA_SUCCESS:
            // console.log(action.data)
            return {
                ...state,
                isOldPreopsoLoading: false,
                old_preOpso: action.data
            };

        case ApprovalAction.OLD_PREOPSO_DATA_FAILED:
            return {
                ...state,
                isOldPreopsoLoading: false,
                error: action.error
            };

        default:
            return {
                ...state
            };
    }
}

export default ApprovalReducer;